import {theme} from "../../../../utils";

export const styles = {
    bannerWrapper: {
        backgroundColor: "#1E1E22",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        pl:'31px',
        pt: "50px",
        alignItems: 'center',
    },
    bannerTitle: {
        ...theme.typography.opticianBodyRegular,
        fontSize: "42px",
        lineHeight: "100%",
        color: "#fff",
        textTransform: "uppercase",
        mt: "24px"
    },
    bannerDescription: {
        ...theme.typography.poppinsBodyLight,
        fontSize: "1rem",
        color: "#fff",
        mt: "1rem"
    },
    overlay: {
        backgroundColor: '#C7D8E5',
        position: "absolute",
        height: "400px",
        width: "400px",
        top: "30px",
        left: "32px",
        mixBlendMode: 'color',
        pointerEvents: "none",
        borderRadius: "50%",
    },
    btnContainer: {
        color: "#fff",
        width: "197px",
        height: "38.33px",
        textTransform: "capitalize",
        borderRadius: '8px',
        position: "absolute",
        bottom: 42,
        right: 0
    },
    btnMobileContainer: {
        color: "#fff",
        width: "197px",
        height: "38.33px",
        textTransform: "capitalize",
        borderRadius: '8px',
        position: "absolute",
        top: 83,
        left: 0
    }
}
